export const stringToCapitalizeCase = (value: string) => (
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
)
